import { isAxiosError } from 'axios';
import { getHttpClient } from 'src/http-client';

const apiUrl = process.env.REACT_APP_FIREBASE_FUNCTIONS_URL as string;

export type FindAutomationRuleSettingsServiceOutputType = {
  type: 'success';
  data: {
		settings: {
			actor: {
				type: 'user';
				authorizedUserId: string;
			} | {
				type: 'service-principal';
			}
		}
  };
} | {
	type: 'error';
}

export const findAutomationRuleSettingsService = async (input: {
  projectId: string;
  organizationName: string;
  automationRuleId: string;
}): Promise<FindAutomationRuleSettingsServiceOutputType> => {
	try {
		const httpClient = getHttpClient();
		const response = await httpClient.get(`${apiUrl}/automation-rule-settings/${input.organizationName}/${input.projectId}/${input.automationRuleId}`);

		return {
			type: 'success',
			data: response.data,
		};
	} catch (error) {
		if (isAxiosError(error)) {
			return {
				type: 'error',
			};
		}

		throw new Error('Failed to check project access by SP.');
	}
};
